export default "__VITE_ASSET__DpekNs1t__"